"use client"

import { Inter, Montserrat } from "next/font/google"
import { CiUser } from "react-icons/ci"
import { TbLogout } from "react-icons/tb"
import { CiShoppingCart } from "react-icons/ci"

import { useEffect, useState } from "react"
import { logoutCustomer } from "@lib/util/customer-utils"
import { useRouter } from "next/navigation"
import { LuContact } from "react-icons/lu"
import PopupContact from "@modules/store/components/popups/popup-contact"

const montserrat = Montserrat({ subsets: ["latin"] })
const inter = Inter({ subsets: ["latin"] })

const Nav = ({ showNavbar }: { showNavbar: boolean }) => {
  const router = useRouter()

  const [popupContactVisible, setPopupContactVisible] = useState(false)

  const handleLogout = () => {
    const logoutResult = logoutCustomer()
    if (!logoutResult) {
      alert("Odhlášení se nezdařilo")
      return
    }

    router.replace("/cz")
  }

  // useEffect(() => {
  //   console.log("Use effect")
  //   if (logCustomerOut) {
  //     const logoutResult = logoutCustomer()
  //     if (!logoutResult) {
  //       alert("Odhlášení se nezdařilo")
  //       setLogCustomerOut(false)
  //       return
  //     }

  //     router.replace("/cz")
  //   }
  // }, [logCustomerOut])

  return (
    <>
      {showNavbar && (
        <div className="flex items-center justify-center w-full">
          <header className="flex items-center justify-between w-full pt-4 pb-4 pl-20 pr-20 max-w-[1920px]">
            <h1
              className={`${montserrat.className} font-medium text-lg md:text-2xl hover:cursor-pointer text-green-800 hover:text-green-950 pl-3 pr-3`}
              onClick={() => window.location.replace("/")}
            >
              Alten s.r.o.
            </h1>

            <div className={`${inter.className} text-lg`}>
              <ul className="flex flex-row items-center pl-3 pr-3 text-lg gap-x-10 lg:gap-x-14 justify-evenly">
                <li
                  className="flex flex-row items-center pt-2 pb-2 font-medium text-center text-gray-800 group hover:text-gray-950 hover:cursor-pointer justify-evenly gap-x-3 hover:font-semibold"
                  onClick={() => setPopupContactVisible(true)}
                >
                  <span>Kontakt</span>
                  <LuContact className="stroke-1 w-7 h-7 group-hover:stroke-2" />
                </li>
                <li
                  className="flex flex-row items-center pt-2 pb-2 font-medium text-center text-gray-800 group hover:text-gray-950 hover:cursor-pointer justify-evenly gap-x-3 hover:font-semibold"
                  onClick={() => window.location.replace(`/cz/`)}
                >
                  <span>Obchod</span>
                  <CiShoppingCart className="w-7 h-7 group-hover:stroke-1" />
                </li>
                <li
                  className="flex flex-row items-center pt-2 pb-2 font-medium text-center text-gray-800 group hover:text-gray-950 hover:cursor-pointer justify-evenly gap-x-3 hover:font-semibold"
                  onClick={() => {
                    window.location.replace(`/cz/account`)
                  }}
                >
                  <span className="w-[150px]">Zákaznický profil</span>
                  <CiUser className="w-7 h-7 group-hover:stroke-1" />
                </li>

                <li
                  className="flex flex-row items-center pt-2 pb-2 font-medium text-center text-gray-800 group hover:text-gray-950 hover:cursor-pointer justify-evenly gap-x-3 hover:font-semibold"
                  onClick={handleLogout}
                >
                  <span className="w-[100px]">Odhlásit se</span>
                  <TbLogout className="stroke-1 w-7 h-7 group-hover:stroke-2" />
                </li>
              </ul>
            </div>
          </header>
          <PopupContact
            visibility={popupContactVisible}
            handleClose={() => {
              setPopupContactVisible(false)
            }}
          />
        </div>
      )}
    </>
  )
}

export default Nav
